import { CheckStatus } from "../../../state/types"
import { Data } from "../../../../../features/ui"
import { useCheckActions } from "../../../actions/checkActions"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { useCheckBuilders } from "../../../builders/checkBuilders"

export const useActions = () => {
    const { buildCheck } = useCheckBuilders()
    const { saveCheck } = useCheckActions()

    const submitCheck = async (
        checkData: Data,
        createMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const paymentDate = checkData.paymentDate! as Date
        const status = paymentDate > new Date() ? CheckStatus.DEFERRED : CheckStatus.EMITTED
        const check = buildCheck({
            ...checkData,
            status
        })
        await saveCheck(check)

        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitCheck
    }
}
